import ProjectItem from "./ProjectItem/ProjectsItem"
import "./Projects.css"
import Aos from "aos"
import "aos/dist/aos.css"
import { useEffect } from "react"
export default function Projects(){
    useEffect(()=>{
        Aos.init({duration:1500, once:true})
        Aos.refreshHard();
    },[])
    return(
        <div className="projects mt-20" id="projects" data-aos="zoom-in">
            <div className="sub-title text-center text-5xl md:text-7xl mb-10 mt-20">
                Projects
            </div>
            <div className="hr w-2/3"></div>
            <div className="projects-content lg:mx-auto mx-5 w-full xl:w-2/3 justify-center gap-x-10 gap-y-10 ">
                <ProjectItem logo="https://img.icons8.com/external-icongeek26-outline-colour-icongeek26/40/000000/external-maze-game-development-icongeek26-outline-colour-icongeek26.png" title="MazeGame" desc="This project was the first Flask-Jinja based fullstack web-game that I have made a while back. The source code represents the beginner mind of myself. I can see the improvement"
                
                goto="https://github.com/moL3sz/MazeGame"
                />


                <ProjectItem logo="https://img.icons8.com/color/40/000000/stopwatch--v1.png" title="StopWatch React" desc="This was my first ever built project with ReactJS. This time I was concured by the essence of modern frameworks. I love it."
                goto="https://github.com/moL3sz/StopWatch/tree/master/timer"
                />

                <ProjectItem logo="https://img.icons8.com/color/40/000000/todo-list--v1.png" title="TodoApp React" desc="As a beginner of web-dev, of course I should build a todo application. I used React as frontend, and have a Python Flask backend. I struggled a lot with CORS-policy..."
                goto="https://github.com/moL3sz/TodoAppReact"
                />


                <ProjectItem logo="https://img.icons8.com/color/40/000000/chat--v1.png" title="Chat App" desc="I wanted to see how the actual realtime data fethcing works. I came across a simple chat application. It kinda budget... but it was a good practice."
                goto="https://github.com/moL3sz/ChatServerReact-Flask"
                />


                <ProjectItem logo="https://img.icons8.com/color/40/000000/dictionary.png" title="Random words" desc="This project is hosted on heroku. I used python as backend. I also improved my web-scraping skills further. I really loved this project."
                goto="https://github.com/moL3sz/RandomSzavak/tree/master"
                />
                <ProjectItem logo="https://img.icons8.com/color/48/000000/sugar-cube.png" title="Interactable Cube" desc="This project was created for one of my university research. In this project you can generate a N*N*N cube with points and can interact with it. Let's say color the point in space what you clicked on a 2D screen. Can you see how hard can it be? Well yees. Feel free to use and play with it." goto="https://github.com/moL3sz/3DCube"/>
            
            </div>
        </div>
    )
}